import { BFFAgent } from '../../../common/BFFAgent';
import {
  GESTION_OPERATIVA_UPDATE_TAKING_CARS_SUCCESS,
  GESTION_OPERATIVA_UPDATE_TAKING_CARS_BEGIN
} from './constants';
import { toast } from 'react-toastify'

export function updateTakingCars() {
  return async (dispatch, getState) => {
    try{
      const { gestionOperativa: { sale, isModified: isModifiedFromState } } = getState();
  
      if (sale?.Taking_cars.length) {
        dispatch({
          type: GESTION_OPERATIVA_UPDATE_TAKING_CARS_BEGIN,
        })
        let peritaciones = {}
        let isModified = isModifiedFromState
        sale.Taking_cars = sale.Taking_cars.filter(tk => tk.requestsId)
        const updatedTakingCars = await Promise.all(sale.Taking_cars.map(async (takingCar) => {
          const peritaje = await BFFAgent.Peritador.getPeritaje(takingCar.license_plate, false, false, null, takingCar.requestsId);
          if(peritaje){
            peritaciones[peritaje.peritaje.servicePatent] = peritaje.peritaje
          }
          if (peritaje.peritajeQuote) {
            // valido si taking car que viene de BD no este actualizado a peritaje finalizado,
            // de ser asi que devuelva lo q ya se encuentra en BD
            const { verification: { vehicle, statusId, kilometraje, verification_type, original_vehicle, original_kilometraje }, appraisal, appraisal_approved } = peritaje.peritajeQuote;
            takingCar.year = original_vehicle?.year?.value || vehicle.year.value
            takingCar.version = original_vehicle?.version?.label || vehicle.version.label
            takingCar.version_id = original_vehicle?.version?.value || vehicle.version.value
            takingCar.mileage = original_kilometraje || kilometraje

            peritaciones[peritaje.peritaje.servicePatent] = {...peritaciones[peritaje.peritaje.servicePatent], verification_type: verification_type }
            const isTakingCarNotUpdated = Number(takingCar.assessed) !== Number(statusId);
            if (isTakingCarNotUpdated) {
              if((statusId === 6 && peritaje.peritaje.presupuesto_reservado) || appraisal !== takingCar.original_price){
                isModified = true
                takingCar = {
                  ...takingCar,
                  assessmentDate: peritaje.peritaje.modificationDate,
                  final_take_price: appraisal,
                  original_price: appraisal,
                  take_improvement_amount: 0,
                  assessed: Number(statusId),
                  brand: vehicle.brand.label,
                  model: vehicle.model.label,
                  updated: true,
                  appraisal,
                  appraisal_approved,
                }
              } else {
                takingCar = {
                  ...takingCar,
                  assessmentDate: peritaje.peritaje.modificationDate,
                  assessed: Number(peritaje.peritaje.statusId),
                  brand: vehicle.brand.label,
                  model: vehicle.model.label,
                  updated: true,
                  appraisal,
                  appraisal_approved,
                }
              }
            } else {
              takingCar = {
                ...takingCar,
                original_price: appraisal,
                appraisal,
                appraisal_approved,
                assessed: Number(peritaje.peritaje.statusId),
                assessmentDate: peritaje.peritaje?.modificationDate,
              }
            }
  
          } else {
            const checkStatusId = Number(takingCar.assessed) !== Number(peritaje.peritaje.statusId);
            if(checkStatusId){
              takingCar = {
                ...takingCar,
                assessed: Number(peritaje.peritaje.statusId),
              }
            }
          }
          return takingCar;
        }))
  
        dispatch({
          type: GESTION_OPERATIVA_UPDATE_TAKING_CARS_SUCCESS,
          data: {takingCarsUpdated: updatedTakingCars, isModified, peritaciones},
        })
      }
    } catch {
      toast.error('Hubo en error. Por favor, inténtalo de nuevo')
    }
  }
}

export function reducer(state, action) {

  switch (action.type) {
    case GESTION_OPERATIVA_UPDATE_TAKING_CARS_SUCCESS:
      return {
        ...state,
        updateTakingCarsPending: false,
        peritaciones: action.data.peritaciones,
        isModified: action.data.isModified,
        sale: {
          ...state.sale,
          Taking_cars: action.data.takingCarsUpdated,
        },
      }
    case GESTION_OPERATIVA_UPDATE_TAKING_CARS_BEGIN: 
      return {
        ...state,
        updateTakingCarsPending: true,
      }
    default:
      return state;
  }
}